import React, { useEffect, useRef } from "react";
import { MdEditNote } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { Card } from "reactstrap";
import { useRefContext } from "../components/ScrollToAppointment";
import { useMediaQuery } from "@mui/material";
import useDoctors from "../hooks/useDoctorsList";

const DoctorDetails = ({ doctor }) => {
  const { scrollToAppointment } = useRefContext();
  const { t, i18n } = useTranslation();

  const thisDivRef = useRef(null);
  const isMobile = useMediaQuery("(max-width:868px)");
  const { images, doctors, loading } = useDoctors();

  const getTranslatedValue = (field, lang) => {
    if (!field) return "";
    return field[lang] || field["en"] || "";
  };
  console.log("docots", doctor);

  const handleGetAppointmentClick = () => scrollToAppointment();
  useEffect(() => {
    if (thisDivRef.current) {
      const position =
        thisDivRef.current.getBoundingClientRect().top + window.pageYOffset;

      setTimeout(() => {
        window.scrollTo({
          top: position - 140,
          behavior: "smooth",
        });
      }, 700);
    }
  }, []);
  console.log("DOCTR", doctor);

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  return (
    <div>
      {/* Doctor's Personal Information Section */}
      <section
        style={{ padding: "40px 20px", backgroundColor: "#f4f8f9" }}
        className="bg-color-grey polygon-pattern-2"
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }} ref={thisDivRef}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <img
              src={doctor?.imageURL}
              alt={doctor?.name || "Doctor"}
              style={{
                height: isMobile ? "250px" : "450px",
                width: "auto",
                borderRadius: "30px",
                marginBottom: "20px",
                objectFit: "cover",
                border: "4px solid #fff",
              }}
            />
            <h2
              style={{ fontSize: "2rem", color: "#2c3e50", fontWeight: "700" }}
            >
              {getTranslatedValue(doctor?.name, i18n.language)}
            </h2>
            <span
              style={{
                fontSize: "1.2rem",
                marginBottom: "20px",
                color: "var(--color-body)",
              }}
              className="specialty"
            >
              {getTranslatedValue(doctor?.role, i18n.language)}
            </span>
            <p
              style={{
                fontSize: "1rem",
                color: "#34495e",
                lineHeight: "1.6",
                marginBottom: "30px",
              }}
              dangerouslySetInnerHTML={{
                __html: decodeHtml(
                  getTranslatedValue(doctor?.description, i18n.language)
                ),
              }}
            />

            <button
              onClick={handleGetAppointmentClick}
              style={{
                padding: "10px 30px",
                fontSize: "1rem",
                backgroundColor: "var(--color-fourth)",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                transition: "0.3s",
              }}
            >
              {t("doctorPage.getAppointment")}
              <MdEditNote style={{ marginLeft: "4px" }} />
            </button>
          </div>
        </div>
      </section>

      {/* Doctors Component for Education, Working Hours, and Services */}

      <section
        style={{
          display: "flex",
          width: "100%",
          backgroundColor: "var(--color-fourth)",
          paddingTop: "40px",
          paddingBottom: "40px",
          position: "relative",
        }}
        className="bg-color-grey polygon-pattern-2"
      >
        {" "}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: "url('assets/img/section-bg/blue-section.png')",
            backgroundSize: "20%",
            backgroundRepeat: "repeat",
            backgroundPosition: "top left",
            filter: "brightness(0.7) contrast(1.2) saturate(0.5)",
            opacity: "0.2",
            zIndex: 1,
          }}
        />{" "}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            zIndex: 3333,
          }}
        >
          {/* Section Heading */}
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <h2
              style={{
                fontSize: "2.3rem",
                fontWeight: "700",
                color: "#fff",
                marginBottom: "10px",
              }}
            >
              {t("doctorPage.background1")}
            </h2>
            <span style={{ fontSize: "1.2rem", color: "#ccc" }}>
              {t("doctorPage.background2")}
            </span>
          </div>

          {/* Education & Experience Cards */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: isMobile ? "90%" : "80%",
            }}
          >
            <Card
              style={{
                padding: isMobile ? "20px 15px" : "30px 25px",
                backgroundColor: "#fff",
                border: "1px solid #e2e2e2",
                borderRadius: "8px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.05)",
                width: "100%",
                maxWidth: "600px",
                transition: "all 0.3s ease-in-out",
              }}
              className="card-glow"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                {/* Role */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  <strong
                    style={{
                      color: "#34495e",
                      fontSize: "1.2rem",
                      minWidth: "200px",
                      marginBottom: "5px",
                    }}
                  >
                    {t("doctorPage.roleName")}:
                  </strong>
                  <span
                    style={{
                      color: "#7f8c8d",
                      fontSize: "1.1rem",
                      textAlign: "left",
                      flexGrow: 1,
                      wordBreak: "break-word",
                    }}
                  >
                    {getTranslatedValue(doctor?.role, i18n.language)}
                  </span>
                </div>

                {/* Education */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  <strong
                    style={{
                      color: "#34495e",
                      fontSize: "1.2rem",
                      minWidth: "200px",
                      marginBottom: "5px",
                    }}
                  >
                    {t("doctorPage.education")}:
                  </strong>
                  <span
                    style={{
                      color: "#7f8c8d",
                      fontSize: "1.1rem",
                      textAlign: "left",
                      flexGrow: 1,
                      wordBreak: "break-word",
                    }}
                  >
                    {getTranslatedValue(doctor?.education, i18n.language)}
                  </span>
                </div>

                {/* Board Certification */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  <strong
                    style={{
                      color: "#34495e",
                      fontSize: "1.2rem",
                      minWidth: "200px",
                      marginBottom: "5px",
                    }}
                  >
                    {t("doctorPage.boardCertification")}:
                  </strong>
                  <span
                    style={{
                      color: "#7f8c8d",
                      fontSize: "1.1rem",
                      textAlign: "left",
                      flexGrow: 1,
                      wordBreak: "break-word",
                    }}
                  >
                    {" "}
                    {getTranslatedValue(doctor?.certification, i18n.language)}
                  </span>
                </div>

                {/* Experience */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  <strong
                    style={{
                      color: "#34495e",
                      fontSize: "1.2rem",
                      minWidth: "200px",
                      marginBottom: "5px",
                    }}
                  >
                    {t("doctorPage.yearsOfPractice")}:
                  </strong>
                  <span
                    style={{
                      color: "#7f8c8d",
                      fontSize: "1.1rem",
                      textAlign: "left",
                      flexGrow: 1,
                      wordBreak: "break-word",
                    }}
                  >
                    {getTranslatedValue(doctor?.experience, i18n.language)}
                  </span>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DoctorDetails;
